import basePageFields from '@fragments/pages/basePageFields';

export default gql`
    fragment DirectoryFragment on Directory {
        ${basePageFields}
    }
`;
